(() => {
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  if (!english) return;
  const normalise = anchor => {
    const raw = anchor.getAttribute('href');
    if (!raw || raw.startsWith('#') || anchor.hasAttribute('hreflang') || anchor.closest('localization-form, .cnm-language-choice')) return;
    let url;
    try { url = new URL(raw, window.location.href); } catch { return; }
    if (url.origin !== window.location.origin || !/^\/(?:collections|products|pages|blogs|cart|search)(?:\/|$)/.test(url.pathname)) return;
    url.pathname = '/en' + url.pathname;
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  };
  const scan = root => root.querySelectorAll('a[href]').forEach(normalise);
  scan(document);
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (anchor) normalise(anchor);
  }, true);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
